module.exports = __webpack_public_path__ + "static/media/EWayBill_Template_1.c065487e.png";